/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d6daab6c18f6607b508ad6a232f29d2>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/epic';
import NewObjectComponent from '@atlaskit/object/epic';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/epic/16';

/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Epic16Icon = function Epic16Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  // Feature flag to migrate to new object package
  if (fg('platform_dst_icon_object_to_object')) {
    // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/React.createElement(NewObjectComponent, {
      label: label,
      testId: testId,
      size: "medium"
    });
  }
  return /*#__PURE__*/React.createElement(IconTile, {
    icon: NewIcon,
    appearance: "purpleBold",
    size: "16",
    label: label,
    testId: testId,
    LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    })
  });
};
Epic16Icon.displayName = 'Epic16Icon';
export default Epic16Icon;